module.exports = __webpack_public_path__ + "static/media/mdm.1526b07f.png";